<app-formulario #ctrl URL="preinscripcion" titulo="Preinscripción / Promoción" [dato]="dato"></app-formulario>
<app-sistema-menu></app-sistema-menu>

<div id="banner" align="center" *ngIf="ctrl.cargando || ctrl.cargarDatosCatalogo || cargando">
    <div class="bloquear-azul">

    </div>
    <span class="tag is-primary is-large "
        style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
        <span class="icon">
            <i class="icon-worldwide fa-spin"></i>
        </span> &nbsp;
        <span>Cargando...</span>
    </span>
</div>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-hidden-mobile menu-izquierda is-1">
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #F2F2F2; border-radius: 1em; ">
 
            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="enviarDatos();">
                <section class="hero is-primary">
                    <div class="hero-body">

                        <nav class="level">
                            <!-- Left side -->
                            <div class="level-left">
                                <div class="level-item">
                                    <p class="title">
                                        <span *ngIf="!ctrl.cargando" class="icon is-medium">
                                            <i class="{{icono}}"></i>
                                        </span>
                                        <span *ngIf="ctrl.cargando" class="icon is-medium">
                                            <i class="icon-worldwide fa-spin"></i>
                                        </span>
                                        <span class="icon is-medium">
                                            <i class="fa"
                                                [ngClass]="ctrl.moduloTitulo == 'Nuevo' ?  'icon-file': 'icon-edit-1'"></i>
                                        </span> {{modulo_actual}}
                                    </p>
                                </div>

                            </div>

                            <!-- Right side -->
                            <div class="level-right">
                                <a class="navbar-item tooltip" (click)="ctrl.regresar()">
                                    <span class="icon fa-2x">
                                        <i class="icon-back"> </i>
                                    </span>
                                    <span class="tooltiptext">Regresar</span>
                                </a>

                                <a class="navbar-item tooltip" [ngClass]="{'is-loading': ctrl.cargando}"
                                    (click)="!ctrl.cargando ? cargarDatos() : ''" id='cargar_datos_actualizar'
                                    *ngIf="ctrl.id">
                                    <span class="icon fa-2x">
                                        <i class="icon-worldwide"></i>
                                    </span>
                                    <span class="tooltiptext">Actualizar</span>
                                </a>

                                <a class="navbar-item tooltip" routerLink="{{url_nuevo}}"
                                    *ngIf="(permisos.indexOf(controlador + '.store') > -1 || permisos.indexOf( 'Sis' + controlador + '.store') > -1) && ctrl.id">
                                    <span class="icon fa-2x">
                                        <i class="icon-file"></i>
                                    </span>
                                    <span class="tooltiptext">Nuevo</span>
                                </a>
                                <!-- *ngIf="(permisos.indexOf(controlador + '.show') > -1 || permisos.indexOf( 'Sis' + controlador + '.show') > -1) && ctrl.id" -->
                                <a class="navbar-item tooltip" (click)="ctrl.imprimir()" *ngIf="(permisos.indexOf(controlador + '.show') > -1 || permisos.indexOf( 'Sis' + controlador + '.show') > -1) && ctrl.id">
                                    <span class="icon fa-2x">
                                        <i class="icon-printer2"></i>
                                    </span>
                                    <span class="tooltiptext">Imprimir</span>
                                </a>

                                <a class="navbar-item tooltip" (click)="imprimir_limpio()" *ngIf="moduloTitulo == 'Nuevo'">
                                    <span class="icon fa-2x">
                                        <i class="icon-printer2"></i>
                                    </span>
                                    <span class="tooltiptext">Imprimir</span>
                                </a>

                                <button class="navbar-item  is-success tooltip" type="submit"
                                    [ngClass]="{'is-loading': ctrl.cargando}"
                                    [disabled]="ctrl.dato.invalid || ctrl.cargando"
                                    *ngIf="controlador != 'CajaOperacionController' && (permisos.indexOf(controlador + '.store') > -1 || permisos.indexOf( 'Sis'+ controlador + '.store') > -1 || permisos.indexOf(controlador + '.update') > -1 || permisos.indexOf( 'Sis' + controlador + '.update') > -1)">
                                    <span class="icon fa-2x has-text-success">
                                        <i class="icon-diskette"> </i>
                                    </span>
                                    <span class="tooltiptext">Guardar</span>
                                </button>
                                <button class="navbar-item  is-danger tooltip" type="button"
                                    [ngClass]="{'is-loading': ctrl.cargando}" [disabled]="ctrl.cargando"
                                    (click)="ctrl.eliminar(ctrl.id)"
                                    *ngIf="(permisos.indexOf(controlador + '.destroy') > -1 || permisos.indexOf( 'Sis' + controlador + '.destroy') > -1) && ctrl.id">
                                    <span class="icon fa-2x has-text-danger">
                                        <i class="icon-trash"></i>
                                    </span>
                                    <span class="tooltiptext">Eliminar</span>
                                </button>
                            </div>
                        </nav>
                        <!-- <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones> -->
                    </div>
                </section>
                <!-- en la carrera se agregan rvoe y ynivel educativo -->
                <section class="section" style="padding: 1rem !important; overflow:auto; height: 85.8vh;">

                    <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                    <a id="catalogos"
                        (click)="ctrl.tipos_regimenes_fiscales = []; ctrl.cargarCatalogo('becas', 'beca', 'cargar_beca_plan'); ctrl.cargarCatalogo('carreras', 'carrera-plan', 'carrera_grupo');   ctrl.cargarCatalogo('logos64', 'logos64', 'logo64');ctrl.cargarCatalogo('paises', 'paises'); ctrl.cargarCatalogo('modalidades','modalidad');ctrl.cargarCatalogo('paiseso', 'paises'); ctrl.cargarCatalogo('estadoso','estados'); ctrl.cargarCatalogo('municipioso', 'municipios'); ctrl.cargarCatalogo('estadosA','estados'); ctrl.cargarCatalogo('municipiosA', 'municipios');"></a>
                    <!-- ctrl.cargarCatalogo('estados','estados'); ctrl.cargarCatalogo('municipios', 'municipios');" -->
                    <a id="logo64" (click)="asignarLogos(ctrl.logos64); "></a>

                    <a id="cargar_datos_dinamicos" (click)="tieneid ? cargarDatos() : ''"></a>
                    <a id="imprimir_local" (click)="imprimir_ficha()"></a>

                    <!-- Información escolar -->
                    <div class="card">
                        <header class="card-header">
                            <p class="card-header-title has-text-primary" style="font-size: 1.25rem;">
                                <i class="fa fa-vcard is-size-4"> </i> &nbsp; Carrera ó estudios
                            </p>
                        </header>
                        <div class="card-content">
                            <div class="content">
                                <div class="columns">
                                    <div class="column is-6">
                                        <label class="label">Carrera</label>
                                        <div class="control has-icons-left has-icons-right">
                                            <!-- <a id="carrera_grupo"
                        (click)="grupo_campania(ctrl.carreras); calcular_beca(ctrl.becas);"></a> -->
                                            <div class="select">
                                                <select class="select" formControlName="carreras_planes_id"
                                                    (change)="limpiar_mod()">
                                                    <option value="0">Seleccione</option>
                                                    <option *ngFor="let carrera of ctrl.carreras"
                                                        value="{{carrera.id}}">
                                                        {{carrera.text}}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="column is-6">
                                        <label class="label">Modalidad</label>
                                        <div class="control has-icons-left has-icons-right">

                                            <div class="select">
                                                <select class="select" formControlName="modalidades_id"
                                                    (change)="grupo_campania(ctrl.carreras,ctrl.modalidades,dato.get('carreras_planes_id').value,dato.get('modalidades_id').value);calcular_beca(ctrl.becas);">
                                                    <option value="0">Seleccione</option>
                                                    <option *ngFor="let modalidad of ctrl.modalidades"
                                                        value="{{modalidad.id}}">
                                                        {{modalidad.text}}
                                                    </option>

                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="columns">
                                    <div class="column is-6">
                                        <label class="label">Grupo</label>
                                        <div class="control has-icons-left has-icons-right">
                                            <a *ngIf="tieneid" id="carrera_grupo"
                                                (click)="grupo_campania(ctrl.carreras,ctrl.modalidades,dato.get('carreras_planes_id').value,dato.get('modalidades_id').value);calcular_beca(ctrl.becas);"></a>
                                            <div class="select">
                                                <a id="calcular_total_alumnos" (click)="total_alumno_grupo();"> </a>
                                                <select class="select" formControlName="grupos_id"
                                                    (change)="total_alumno_grupo()" >
                                                    <option value="0">Seleccione</option>
                                                    <option *ngFor="let grupo of grupos" value={{grupo.id}}>
                                                        {{grupo.text}}
                                                    </option>

                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="column is-6" *ngIf="!tieneid">
                                        <br>
                                        <a class="button is-medium" title="Capacidad del grupo">
                                            <span class="icon">
                                                <i class="fa fa-institution"></i>
                                            </span>
                                            <span>{{capacidad_grupo}}</span>
                                        </a>
                                        <a class="button is-medium" title="Alumnos en el grupo">
                                            <span class="icon">
                                                <i class="fa fa-child"></i>
                                            </span>
                                            <span>{{total_alumnos}}</span>
                                        </a>
                                        <a class="button is-medium" title="Lugares disponibles">
                                            <span class="icon has-text-success">
                                                <i class="fa fa-child"></i>
                                            </span>
                                            <span>{{capacidad_grupo - total_alumnos}}</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="content">
            <div class="columns">
                <div class="column is-6">
                    <label class="label">Carreras:</label>
                    <div class="control has-icons-left has-icons-right">
                        <ng-select2 name="carreras_planes_id"
                            [disabled]="ctrl.carreras ? ctrl.carreras.length == 0 ? true : false : true"
                            [options]="ctrl.optionSelect"
                            [value]="ctrl.dato.controls.carreras_planes_id.value"
                            [data]="ctrl.carreras"
                            (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.carreras_planes_id, '', '', 'carrera_grupo');">
                        </ng-select2>

                        <a id="carrera_grupo"
                            (click)="grupo_campania(ctrl.carreras); calcular_beca(ctrl.becas);"></a>

                        <span class="icon is-small is-right"
                            *ngIf="ctrl.dato.get('planes_pagos_id').hasError('required') ">
                            <i class="fa fa-warning"></i>
                        </span>
                        <span class="help is-danger"
                            *ngIf="ctrl.dato.get('planes_pagos_id').hasError('required') ">Este
                            campo es requerido.</span>
                    </div>
                </div>
                <div class="column is-6">
                    <label class="label">Modalidad:</label>
                    <div class="control has-icons-left has-icons-right">
                        <ng-select2
                            [disabled]="ctrl.modalidades ? ctrl.modalidades.length == 0 ? true : false : true"
                            name="modalidades_id" [options]="ctrl.optionSelect"
                            [value]="ctrl.dato.controls.modalidades_id.value"
                            [data]="ctrl.modalidades"
                            (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.modalidades_id, '', '', 'carrera_grupo');"></ng-select2>
                        <span class="icon is-small is-right"
                            *ngIf="ctrl.dato.get('modalidades_id').hasError('required') ">
                            <i class="fa fa-warning"></i>
                        </span>
                        <span class="help is-danger"
                            *ngIf="ctrl.dato.get('modalidades_id').hasError('required') ">Este campo
                            es
                            requerido.</span>
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column is-6">
                    <label class="label">Grupo</label>
                    <div class="control has-icons-left has-icons-right">
                        <a id="calcular_total_alumnos" (click)="total_alumno_grupo();"> </a>
                        <ng-select2 [disabled]="grupos.length == 0" name="grupos_id"
                            [options]="ctrl.optionSelect"
                            [value]="ctrl.dato.controls.grupos_id.value" [data]="grupos"
                            (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.grupos_id, '', '', 'calcular_total_alumnos');"></ng-select2>
                        <span class="icon is-small is-right"
                            *ngIf="ctrl.dato.get('grupos_id').hasError('required') ">
                            <i class="fa fa-warning"></i>
                        </span>
                        <span class="help is-danger"
                            *ngIf="ctrl.dato.get('grupos_id').hasError('required') ">Este campo es
                            requerido.</span>
                    </div>
                </div>
                <div class="column is-6">
                    <br>
                    <a class="button is-medium" title="Capacidad del grupo">
                        <span class="icon">
                            <i class="fa fa-institution"></i>
                        </span>
                        <span>{{capacidad_grupo}}</span>
                    </a>
                    <a class="button is-medium" title="Alumnos en el grupo">
                        <span class="icon">
                            <i class="fa fa-child"></i>
                        </span>
                        <span>{{total_alumnos}}</span>
                    </a>
                    <a class="button is-medium" title="Lugares disponibles">
                        <span class="icon has-text-success">
                            <i class="fa fa-child"></i>
                        </span>
                        <span>{{capacidad_grupo - total_alumnos}}</span>
                    </a>
                </div>
            </div>
        </div> -->
                        </div>
                    </div>

                    <!--  Plan de pago y Beca -->
                    <div class="card">
                        <header class="card-header">
                            <p class="card-header-title has-text-primary" style="font-size: 1.25rem;">
                                <i class="fa fa-dollar is-size-4"> </i> &nbsp; Colegiaturas y Beca
                            </p>
                        </header>
                        <div class="card-content">
                            <div class="content">
                                <div class="columns">
                                    <div class="column is-6">
                                        <p>Los montos de Inscripción, reinscripción y colegiaturas se extraen del plan
                                            de pagos vigente. Si el alumno es acreedor a una beca o convenio de pago
                                            debe elegir la opción que convenga.</p>
                                    </div>
                                    <div class="column is-6">
                                        <label class="label">Becas/Convenios:</label>
                                        <div class="control has-icons-left has-icons-right">
                                            <a id="cargar_beca_plan" (click)="calcular_beca(ctrl.becas); "> </a>
                                            <ng-select2
                                                [disabled]="ctrl.becas ? ctrl.becas.length == 0 ? true : false : true"
                                                name="becas_id" [options]="ctrl.optionSelect"
                                                [value]="ctrl.dato.controls.becas_id.value" [data]="ctrl.becas"
                                                (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.becas_id, '', '', 'cargar_beca_plan');"></ng-select2>
                                        </div>
                                    </div>
                                </div>
                                <div class="columns">
                                    <table class="table" style="width:100%;" id="beca">
                                        <thead>
                                            <tr>
                                                <th> </th>
                                                <th> Inscripción </th>
                                                <th> Reinscripción </th>
                                                <th> Colegiatura </th>
                                            </tr>
                                        </thead>


                                        <tbody>
                                            <tr *ngIf="plan_seleccionado['db61c2cb92dde2df6e62b4b0744f9dce'].importe != ''"> 
                                                <td style="width:40%; font-size:small;">Plan de pago actual</td>
                                                <td style="width:20%; font-weight:bold; font-size:large;">{{plan_seleccionado['db61c2cb92dde2df6e62b4b0744f9dce'].importe | currency}}</td>
                                                <td style="width:20%; font-weight:bold; font-size:large;">{{plan_seleccionado['83dae74b6269ce625f4babc3fa613be2'].importe | currency}}</td>
                                                <td style="width:20%; font-weight:bold; font-size:large;">{{plan_seleccionado['12a00afca32cafa9f493f73f2b7f8bcf'].importe | currency}}</td>
                                            </tr>
                                            <tr *ngIf="beca_seleccionado.id != ''">
                                                <td style="font-size:small;">Beca: {{beca_seleccionado.nombre}}</td>
                                                <td style="font-weight:bold; font-size:large;">
                                                    ({{beca_seleccionado.becas_detalles_articulos['db61c2cb92dde2df6e62b4b0744f9dce'].importe}} {{ beca_seleccionado.es_porcentaje ? '%' : ''}}) {{beca_seleccionado.becas_detalles_articulos['db61c2cb92dde2df6e62b4b0744f9dce'].total | currency}}</td>
                                                <td style="font-weight:bold; font-size:large;">
                                                    ({{beca_seleccionado.becas_detalles_articulos['83dae74b6269ce625f4babc3fa613be2'].importe}}) {{ beca_seleccionado.es_porcentaje ? '%' : ''}} {{beca_seleccionado.becas_detalles_articulos['83dae74b6269ce625f4babc3fa613be2'].total | currency}}</td>
                                                <td style="font-weight:bold; font-size:large;">
                                                    ({{beca_seleccionado.becas_detalles_articulos['12a00afca32cafa9f493f73f2b7f8bcf'].importe}}) {{ beca_seleccionado.es_porcentaje ? '%' : ''}} {{beca_seleccionado.becas_detalles_articulos['12a00afca32cafa9f493f73f2b7f8bcf'].total | currency}}</td>
                                            </tr>
                                            <tr *ngIf="beca_seleccionado.id != ''">
                                                <td style="font-size:small;">Importe a pagar</td>
                                                <td style="width:20%; font-weight:bold; font-size:large;">
                                                    {{(plan_seleccionado['db61c2cb92dde2df6e62b4b0744f9dce'].importe - beca_seleccionado.becas_detalles_articulos['db61c2cb92dde2df6e62b4b0744f9dce'].total)| currency}}</td>
                                                <td style="width:20%; font-weight:bold; font-size:large;">
                                                    {{(plan_seleccionado['83dae74b6269ce625f4babc3fa613be2'].importe - beca_seleccionado.becas_detalles_articulos['83dae74b6269ce625f4babc3fa613be2'].total)| currency}}</td>
                                                <td style="width:20%; font-weight:bold; font-size:large;">
                                                    {{(plan_seleccionado['12a00afca32cafa9f493f73f2b7f8bcf'].importe - beca_seleccionado.becas_detalles_articulos['12a00afca32cafa9f493f73f2b7f8bcf'].total)| currency}}</td>
                                            </tr>
                                        </tbody>



                                        <!--<tbody> 
                                            <tr>
                                                <td style="width:40%; font-size:small;">Plan de pago actual</td>
                                                <td style="width:20%; font-weight:bold; font-size:large;">
                                                    {{plan_seleccionado[1].importe | currency}}</td>
                                                <td style="width:20%; font-weight:bold; font-size:large;">
                                                    {{plan_seleccionado[2].importe | currency}}</td>
                                                <td style="width:20%; font-weight:bold; font-size:large;">
                                                    {{plan_seleccionado[3].importe | currency}}</td>
                                            </tr>
                                            <tr *ngIf="beca_seleccionado.id != ''">
                                                <td style="font-size:small;">Beca: {{beca_seleccionado.nombre}}</td>
                                                <td style="font-weight:bold; font-size:large;">
                                                    ({{beca_seleccionado.becas_detalles_articulos[1].importe}} {{
                                                    beca_seleccionado.es_porcentaje ? '%' : ''}})
                                                    {{beca_seleccionado.becas_detalles_articulos[1].total | currency}}
                                                </td>
                                                <td style="font-weight:bold; font-size:large;">
                                                    ({{beca_seleccionado.becas_detalles_articulos[2].importe}}) {{
                                                    beca_seleccionado.es_porcentaje ? '%' : ''}}
                                                    {{beca_seleccionado.becas_detalles_articulos[2].total | currency}}
                                                </td>
                                                <td style="font-weight:bold; font-size:large;">
                                                    ({{beca_seleccionado.becas_detalles_articulos[3].importe}}) {{
                                                    beca_seleccionado.es_porcentaje ? '%' : ''}}
                                                    {{beca_seleccionado.becas_detalles_articulos[3].total | currency}}
                                                </td>
                                            </tr>
                                            <tr *ngIf="beca_seleccionado.id != ''">
                                                <td style="font-size:small;">Importe a pagar</td>
                                                <td style="width:20%; font-weight:bold; font-size:large;">
                                                    {{(plan_seleccionado[1].importe -
                                                    beca_seleccionado.becas_detalles_articulos[1].total)| currency}}
                                                </td>
                                                <td style="width:20%; font-weight:bold; font-size:large;">
                                                    {{(plan_seleccionado[2].importe -
                                                    beca_seleccionado.becas_detalles_articulos[2].total)| currency}}
                                                </td>
                                                <td style="width:20%; font-weight:bold; font-size:large;">
                                                    {{(plan_seleccionado[3].importe -
                                                    beca_seleccionado.becas_detalles_articulos[3].total)| currency}}
                                                </td>
                                            </tr>
                                        </tbody>-->
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <br>

                    <div>
                        <!-- formulario dinamico -->

                        <div class="card">
                            <header class="card-header">
                                <p class="card-header-title has-text-primary" style="font-size: 1.25rem;">
                                    <i class="fa fa-vcard is-size-4"> </i> &nbsp; Datos del
                                    alumno
                                </p>
                                <!-- <a href="javascript:void()" class="card-header-icon" aria-label="more options"
                                    (click)="acordeon[1] = !acordeon[1]">
                                    <span class="icon">
                                        <i class="fa " [ngClass]="acordeon[1] ? 'fa-angle-down' : 'fa-angle-up'"
                                            aria-hidden="true"></i>
                                    </span>
                                </a> -->
                            </header>
                            <!-- <div class="card-content" [ngClass]="acordeon[1] ? 'is-hidden' : ''"> -->
                            <div class="card-content">
                                <div class="content">
                                    <div class="columns is-desktop">
                                        <div class="column is-4">
                                            <div class="field">
                                                <label class="label">Nombre(s)</label>
                                                <div class="control is-expanded  has-icons-right">
                                                    <input class="input" type="text" placeholder="Nombre(s)"
                                                        formControlName="nombre">
                                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre').hasError('required') ">
                                                            <i class="fa fa-warning"></i>
                                                          </span>
                                                          <span class="help is-danger" *ngIf="ctrl.dato.controls.nombre.hasError('required') ">Este campo es requerido.</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="column is-4">
                                            <div class="field">
                                                <label class="label">Apellido paterno</label>
                                                <div class="control has-icons-right">
                                                    <input class="input" type="text" placeholder="Apellido paterno"
                                                        formControlName="apellido_paterno">
                                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.get('apellido_paterno').hasError('required') ">
                                                            <i class="fa fa-warning"></i>
                                                          </span>
                                                          <span class="help is-danger" *ngIf="ctrl.dato.controls.apellido_paterno.hasError('required') ">Este campo es requerido.</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="column is-4">
                                            <div class="field">
                                                <label class="label">Apellido materno</label>
                                                <div class="control has-icons-right">
                                                    <input class="input" type="text" placeholder="Apellido materno"
                                                        formControlName="apellido_materno">
                                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.get('apellido_materno').hasError('required') ">
                                                            <i class="fa fa-warning"></i>
                                                          </span>
                                                          <span class="help is-danger" *ngIf="ctrl.dato.controls.apellido_materno.hasError('required') ">Este campo es requerido.</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="columns is-desktop">
                                        <div class="column is-4">
                                            <div class="field">
                                                <label class="label">CURP</label>
                                                <div class="control has-icons-right">
                                                    <input class="input" type="text" placeholder="CURP" maxlength="18"
                                                        formControlName="curp">
                                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.get('curp').hasError('required') ">
                                                            <i class="fa fa-warning"></i>
                                                          </span>
                                                          <span class="help is-danger" *ngIf="ctrl.dato.get('curp').hasError('minlength') ">Este campo es requerido.</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="column is-4">
                                            <div class="field">
                                                <label class="label">Fecha de nacimiento</label>
                                                <p class="control has-icons-right">
                                                    <input class="input" formControlName="fecha_nacimiento" type="date">
                                                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('fecha_nacimiento').hasError('required') ">
                                                        <i class="fa fa-warning"></i>
                                                      </span>
                                                      <span class="help is-danger" *ngIf="ctrl.dato.controls.fecha_nacimiento.hasError('required') ">Este campo es requerido.</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="column is-4">

                                            <div class="field">
                                                <label class="label">Sexo</label>
                                                <div class="control has-icons-left has-icons-right"
                                                    style="margin-top: 1em;">
                                                    <input id="sexo_f" name="sexo" value="F" class="styled" type="radio"
                                                        style="transform: scale(1.5); margin-right: 0.5em;"
                                                        formControlName="sexo">
                                                    <label for="sexo_f">
                                                        Femenino
                                                    </label>

                                                    <input id="sexo_m" name="sexo" value="M" class="styled" type="radio"
                                                        style="transform: scale(1.5); margin-left: 1.5em; margin-right: 0.5em;"
                                                        formControlName="sexo">
                                                    <label for="sexo_m">
                                                        Masculino
                                                    </label>
                                                </div>

                                            </div>
                                        </div>
                                    </div>


                                    <div class="columns is-desktop">

                                        <div class="column is-4">
                                            <label class="label">Pais de nacimiento</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <div class="select">
                                                    <select class="select" formControlName="pais_nacimiento">
                                                        <option *ngFor="let item of paises_nacimiento;"
                                                            value="{{item.id}}">
                                                            {{item.nombre}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="column is-4">
                                            <label class="label">Estado de nacimiento</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <div class="select">
                                                    <select class="select" formControlName="estado_nacimiento">
                                                        <option *ngFor="let item of estados_nacimiento;"
                                                            value="{{item.id}}">
                                                            {{item.nombre}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="column is-4">
                                            <label class="label">Pais de procedencia</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <div class="select">
                                                    <select class="select" formControlName="pais_procedencia">
                                                        <option *ngFor="let item of paises_nacimiento;"
                                                            value="{{item.id}}">
                                                            {{item.nombre}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                    </div>


                                    <div class="columns is-desktop">

                                        <div class="column is-4">
                                            <label class="label">Estado civil</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <div class="select">
                                                    <select class="select" formControlName="estado_civil_id">
                                                        <option *ngFor="let item of estados_civiles;"
                                                            value="{{item.id}}">
                                                            {{item.descripcion}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="column is-4">
                                            <label class="label">Idioma</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <div class="select">
                                                    <select class="select" formControlName="idioma">

                                                        <option *ngFor="let item of idiomas;" value="{{item.id}}">
                                                            {{item.descripcion}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="column is-4">
                                            <label class="label">Necesidad educativa especial</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <div class="select">
                                                    <select class="select"
                                                        formControlName="necesidad_educativa_especial">
                                                        <option *ngFor="let item of necesidades_especiales;"
                                                            value="{{item.id}}">
                                                            {{item.descripcion}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <br>
                    <div>
                        <div class="card">
                            <header class="card-header">
                                <p class="card-header-title has-text-primary" style="font-size: 1.25rem;">
                                    <i class="fa fa-vcard is-size-4"> </i> &nbsp; Datos de contacto
                                </p>
                            </header>
                            <div class="card-content">
                                <div class="content">
                                    <div class="columns is-desktop">
                                        <div class="column is-4">
                                            <div class="field">
                                                <label class="label">Correo eléctronico</label>
                                                <div class="control has-icons-right">
                                                    <input class="input" type="text" placeholder="ejemplo@dominio.com"
                                                        formControlName="email">
                                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.get('email').hasError('required') ">
                                                            <i class="fa fa-warning"></i>
                                                          </span>
                                                          <span class="help is-danger" *ngIf="ctrl.dato.controls.email.hasError('required') ">Este campo es requerido.</span>
                                                          <span class="help is-danger" *ngIf="ctrl.dato.controls.email.hasError('email') ">Ingresar correo valido.</span>
                                                </div>
                                            </div>
                                        </div>


                                        <div class="column is-4">
                                            <div class="field">
                                                <label class="label">Teléfono</label>
                                                <div class="control">
                                                    <input class="input" type="text" placeholder="telefono"
                                                        maxlength="10" formControlName="telefono">
                                                </div>
                                            </div>
                                        </div>


                                        <div class="column is-4">
                                            <div class="field">
                                                <label class="label">Teléfono 2</label>
                                                <div class="control">
                                                    <input class="input" type="text" placeholder="telefono"
                                                        maxlength="10" formControlName="telefono2">
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>

                    <br>

                    <div formGroupName="datos_adicionales">
                        <div class="card">
                            <header class="card-header">
                                <p class="card-header-title has-text-primary" style="font-size: 1.25rem;">
                                    <i class="fa fa-vcard is-size-4"> </i> &nbsp; Domicilio del
                                    alumno
                                </p>
                            </header>
                            <div class="card-content">
                                <div class="content">
                                    <div class="columns is-desktop">
                                        <div class="column is-4">
                                            <label class="label">Estado</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <div class="select">
                                                    <select class="select"
                                                        (change)="ctrl.catalogoDependiente('municipios', 'municipiosA',dato.get('datos_adicionales').get('domicilio_estado').value)"
                                                        formControlName="domicilio_estado">
                                                        <option value="0">Seleccione</option>
                                                        <option *ngFor="let item of ctrl.estadosA;" value="{{item.id}}">
                                                            {{item.nombre}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="column is-4">
                                            <label class="label">Municipio</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <div class="select">
                                                    <select class="select" formControlName="domicilio_municipio">
                                                        <option value="0">Seleccione</option>
                                                        <option *ngFor="let item of ctrl.municipiosA;"
                                                            value="{{item.id}}">
                                                            {{item.nombre}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="column is-4">
                                            <div class="field">
                                                <label class="label">Colonia</label>
                                                <p class="control has-icons-left has-icons-right">
                                                    <input class="input" formControlName="domicilio_colonia"
                                                        type="text">
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="columns is-desktop">
                                        <div class="column is-8">
                                            <div class="field">
                                                <label class="label">Calle</label>
                                                <p class="control has-icons-left has-icons-right">
                                                    <input class="input" formControlName="domicilio_calle" type="text">
                                                </p>
                                            </div>
                                        </div>

                                        <div class="column is-2">
                                            <div class="field">
                                                <label class="label">N° Ext.</label>
                                                <p class="control has-icons-left has-icons-right">
                                                    <input class="input" formControlName="domicilio_exterior"
                                                        type="text">
                                                </p>
                                            </div>
                                        </div>

                                        <div class="column is-2">
                                            <div class="field">
                                                <label class="label">N° Int.</label>
                                                <p class="control has-icons-left has-icons-right">
                                                    <input class="input" formControlName="domicilio_interior"
                                                        type="number">
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="columns is-desktop">
                                        <div class="column is-12">
                                            <div class="field">
                                                <label class="label">Referencias del domicilio</label>
                                                <div class="control">
                                                    <textarea formControlName="domicilio_referencias"
                                                        class="textarea has-fixed-size"
                                                        placeholder="Referencias del domicilio"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <br>


                    <div formGroupName="datos_adicionales">
                        <div class="card">
                            <header class="card-header">
                                <p class="card-header-title has-text-primary" style="font-size: 1.25rem;">
                                    <i class="icon-list2 is-size-4"> </i> &nbsp; Antecedentes
                                    escolares
                                </p>
                            </header>
                            <div class="card-content">
                                <div class="content">
                                    <div class="columns is-desktop">
                                        <div class="column is-6">
                                            <div class="field">
                                                <label class="label">Institución de procedencia</label>
                                                <p class="control has-icons-left has-icons-right">
                                                    <input class="input" formControlName="escuela_procedencia"
                                                        type="text">
                                                </p>
                                            </div>
                                        </div>
                                        <div class="column is-6">
                                            <div class="field">
                                                <label class="label">Sector</label>
                                                <div class="control has-icons-left has-icons-right"
                                                    style="margin-top: 1em;">
                                                    <input id="sector_pu" name="sector_escuela_procedencia" [value]="1"
                                                        class="styled" type="radio"
                                                        style="transform: scale(1.5);margin-right: 0.5em;"
                                                        formControlName="sector_escuela_procedencia">
                                                    <label for="sector_pu">
                                                        Público
                                                    </label>

                                                    <input id="sector_p" name="sector_escuela_procedencia" [value]="2"
                                                        class="styled" type="radio"
                                                        style="transform: scale(1.5); margin-left: 1.5em; margin-right: 0.5em;"
                                                        formControlName="sector_escuela_procedencia">
                                                    <label for="sector_p">
                                                        Privado
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="columns is-desktop">
                                        <div class="column is-12">
                                            <label class="label">Medio de Promoción</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <div class="select">
                                                    <select class="select" formControlName="medio_promocion">
                                                        <option value="0">Seleccione</option>
                                                        <option *ngFor="let item of tipos_promocion;"
                                                            value="{{item.id}}">
                                                            {{item.descripcion}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <br>

                    <div formGroupName="datos_tutores">
                        <div class="card">
                            <header class="card-header">
                                <p class="card-header-title has-text-primary" style="font-size: 1.25rem;">
                                    <i class="icon-info is-size-4"> </i> &nbsp; Datos del tutor
                                </p>
                            </header>
                            <div class="card-content">
                                <div class="content">
                                    <!-- <label for="">Tutor 1</label> -->
                                    <div class="columns is-desktop">
                                        <div class="column is-6">
                                            <div class="field">
                                                <label class="label">Nombre</label>
                                                <p class="control has-icons-left has-icons-right">
                                                    <input class="input" formControlName="nombre" type="text">
                                                </p>
                                            </div>
                                        </div>
                                        <div class="column is-6">
                                            <div class="field">
                                                <label class="label">Parentesco</label>
                                                <div class="control has-icons-left has-icons-right">
                                                    <div class="select">
                                                        <select class="select" formControlName="parentesco">
                                                            <option value="0">Seleccione</option>
                                                            <option *ngFor="let item of parentescos;"
                                                                value="{{item.id}}">
                                                                {{item.descripcion}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <!-- <div class="control has-icons-left has-icons-right">
                                                    <input id="padre" name="parentesco" value="1" class="styled"
                                                        style="transform: scale(1.5); margin-right: 0.5em;" type="radio"
                                                        formControlName="parentesco">
                                                    <label for="padre">
                                                        Padre
                                                    </label>

                                                    <input id="madre" name="parentesco" value="2" class="styled"
                                                        style="transform: scale(1.5); margin-left: 1.5em; margin-right: 0.5em;"
                                                        type="radio" formControlName="parentesco">
                                                    <label for="madre">
                                                        Madre
                                                    </label>

                                                    <input id="otro" name="parentesco" value="3" class="styled"
                                                        style="transform: scale(1.5); margin-left: 1.5em; margin-right: 0.5em;"
                                                        type="radio" formControlName="parentesco">
                                                    <label for="otro">
                                                        Otro
                                                    </label>
                                                </div> -->
                                            </div>
                                        </div>
                                    </div>

                                    <div class="columns is-desktop">
                                        <div class="column is-6">
                                            <div class="field">
                                                <label class="label">Teléfono</label>
                                                <div class="control">
                                                    <input class="input" type="text" placeholder="telefono"
                                                        maxlength="10" formControlName="telefono">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="column is-6">
                                            <div class="field">
                                                <label class="label">Correo eléctronico</label>
                                                <div class="control">
                                                    <input class="input" type="text" placeholder="ejemplo@dominio.com"
                                                        formControlName="email">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <hr>


                                    <div class="columns is-desktop">
                                        <div class="column is-6">
                                            <div class="field">
                                                <label class="label">Nombre</label>
                                                <p class="control has-icons-left has-icons-right">
                                                    <input class="input" formControlName="nombre_2" type="text">
                                                </p>
                                            </div>
                                        </div>
                                        <div class="column is-6">
                                            <div class="field">
                                                <label class="label">Parentesco</label>
                                                <div class="control has-icons-left has-icons-right">
                                                    <div class="select">
                                                        <select class="select" formControlName="parentesco_2">
                                                            <option value="0">Seleccione</option>
                                                            <option *ngFor="let item of parentescos;"
                                                                value="{{item.id}}">
                                                                {{item.descripcion}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="columns is-desktop">
                                        <div class="column is-6">
                                            <div class="field">
                                                <label class="label">Teléfono</label>
                                                <div class="control">
                                                    <input class="input" type="text" placeholder="telefono"
                                                        maxlength="10" formControlName="telefono2">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="column is-6">
                                            <div class="field">
                                                <label class="label">Correo eléctronico</label>
                                                <div class="control">
                                                    <input class="input" type="text" placeholder="ejemplo@dominio.com"
                                                        formControlName="email2">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <br>

                    <div formGroupName="datos_adicionales">
                        <div class="card">
                            <header class="card-header">
                                <p class="card-header-title has-text-primary" style="font-size: 1.25rem;">
                                    <i class="fa fa-medkit is-size-4"> </i> &nbsp; Datos de salud
                                </p>
                            </header>
                            <div class="card-content">
                                <div class="content">
                                    <div class="columns is-desktop">
                                        <div class="column is-4">
                                            <label class="label">Tipo de sangre</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <div class="select">
                                                    <select class="select" formControlName="tipo_sangre">
                                                        <option value="0">Seleccione</option>
                                                        <option *ngFor="let tipo of tipos_de_sangre ;"
                                                            value="{{tipo.id}}">
                                                            {{tipo.descripcion}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="column is-4">
                                            <label class="label">Factor Rh</label>
                                            <div class="control has-icons-left has-icons-right">
                                                <div class="select">
                                                    <select class="select" formControlName="factor_rh">
                                                        <option value="0">Seleccione</option>
                                                        <option *ngFor="let factor of factor_rh ;"
                                                            value="{{factor.id}}">
                                                            {{factor.descripcion}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="column is-4">
                                            <div class="field">
                                                <label class="label">Alergias</label>
                                                <div class="control has-icons-left has-icons-right">
                                                    <input id="si" name="presenta_alergias" [value]="1" class="styled"
                                                        style="transform: scale(1.5); margin-right: 0.5em;" type="radio"
                                                        formControlName="presenta_alergias">
                                                    <label for="si">
                                                        Sí
                                                    </label>

                                                    <input id="no" name="presenta_alergias" [value]="2" class="styled"
                                                        style="transform: scale(1.5); margin-left: 1.5em; margin-right: 0.5em;"
                                                        type="radio" formControlName="presenta_alergias">
                                                    <label for="no">
                                                        No
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="columns is-desktop"
                                        *ngIf="dato.get('datos_adicionales').get('presenta_alergias').value == 1">
                                        <div class="column is-12">
                                            <div class="field">
                                                <label class="label">Cuales son</label>
                                                <div class="control">
                                                    <textarea formControlName="alergias" class="textarea has-fixed-size"
                                                        rows="1" placeholder="Alergias"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="columns is-desktop">
                                        <div class="column is-12">
                                            <div class="field">
                                                <label class="label">Padecimientos</label>
                                                <div class="control">
                                                    <textarea formControlName="padecimientos"
                                                        class="textarea has-fixed-size" rows="2"
                                                        placeholder="Padecimientos"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="columns is-desktop">
                                        <div class="column is-12">
                                            <div class="field">
                                                <label class="label">Contacto médico</label>
                                                <p class="control has-icons-left has-icons-right">
                                                    <input class="input" formControlName="contacto_medico" type="text">
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="columns is-desktop">
                                        <div class="column is-6">
                                            <div class="field">
                                                <label class="label">Teléfono</label>
                                                <p class="control has-icons-left has-icons-right">
                                                    <input class="input" formControlName="telefono_medico"
                                                        maxlength="10" type="text">
                                                </p>
                                            </div>
                                        </div>

                                        <div class="column is-6">
                                            <div class="field">
                                                <label class="label">Télefono 2</label>
                                                <p class="control has-icons-left has-icons-right">
                                                    <input class="input" formControlName="telefono_medico2"
                                                        maxlength="10" type="text">
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <br>

                    <div formGroupName="preinscripciones_requisitos">
                        <div class="card" *ngFor="let form of requisito; let i = index">
                            <header class="card-header">
                                <p class="card-header-title has-text-primary" style="font-size: 1.25rem;">
                                    <i class="fa fa-vcard is-size-4"> </i> &nbsp; {{
                                    form.nombre }}
                                </p>

                            </header>

                            <div class="card-content">

                                <div class="content">
                                    <div class="columns" *ngFor="let column of form.formularios_requisitos">
                                        <div class="column is-4" *ngFor="let c of column">


                                            <label class="checkbox">
                                                <input type="checkbox" formControlName="{{c.id}}"
                                                    style="transform: scale(1.5); margin-left: 1.5em; margin-right: 0.5em;">
                                                {{c.nombre}}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <br>

                    <div class="card">
                        <header class="card-header">
                            <p class="card-header-title has-text-primary" style="font-size: 1.25rem;">
                                <i class="fa fa-vcard is-size-4"> </i> &nbsp; Inscripción condicionada
                            </p>
                        </header>
                        <div class="card-content">
                            <div class="content">
                                <div class="columns is-desktop">
                                    <div class="column is-6">
                                        <label class="checkbox">
                                            <input type="checkbox" formControlName="inscripcion_condicionada"
                                                style="transform: scale(1.5); margin-right: 0.5em;">
                                            Imprimir mensaje condicionado
                                        </label>
                                    </div>

                                    <div class="column is-6">
                                        <div class="field">
                                            <label class="label">Fecha de entrega</label>
                                            <p class="control has-icons-left has-icons-right">
                                                <input class="input" formControlName="fecha_condicionada" type="date">
                                            </p>
                                        </div>
                                    </div>

                                </div>

                                <div class="columns is-desktop">
                                    <div class="column is-6">
                                        <label class="checkbox">
                                            <input type="checkbox" formControlName="condicion_adicional"
                                                style="transform: scale(1.5); margin-right: 0.5em;">
                                            Imprimir condición para titulación
                                        </label>
                                    </div>
                                </div>

                                <!-- <div class="columns is-desktop">
                                    <div class="column is-12">
                                        <div class="field">
                                            <label class="label">Condiciones</label>
                                            <div class="control">
                                                <textarea formControlName="condiciones" class="textarea has-fixed-size"
                                                    rows="5" placeholder="Condiciones"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->

                            </div>
                        </div>
                    </div>

                    
                    <br>
                    <div class="card" formGroupName="datos_adicionales">
                        <div class="card-content">
                            <div class="content">
                                <div class="columns is-desktop">
                                    <div class="column is-12">
                                        <div class="field">
                                            <label class="label">Observaciones</label>
                                            <div class="control">
                                                <textarea formControlName="observaciones"
                                                    class="textarea has-fixed-size" placeholder="Observaciones"
                                                    rows="5"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
            </form>
        </div>
    </div>
</div>

<div id="condicion" style="display: none">
    <div align="justify" style="font-size: 8pt">
        <span>*En caso contrario estoy sabedor de que causaré baja temporal, hasta regularizarme con los documentos que
            me solicta
            la institución, Por lo que asumo la responsabilidad total al no egresar en tiempo y forma del ciclo escolar
            al que se me
            dio la oportunidad de ingresar, eximiendo de toda responsabilidad al {{ configuracion.empresa.nombre }}
            {{ configuracion.empresa.subnombre }}
        </span>
    </div>
</div>

<div id="contenido_tab" style="display: none">
</div>